import React, { useContext, useLayoutEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { GlobalContext } from "../../../context/GlobalContext";
import dayjs from "dayjs";

// `value`/`onChange` are optional and only exist for StepOwnership.js's
// multi-owner rows (PD-6 "3+ owners" support), where each row needs its own
// independent date instead of the single shared
// `questions.business.secondOwnerDob` slot below. Omitting them keeps this
// component's original global-state-backed behavior unchanged for its other
// caller, the old pre-PD-6 flow's SecondOwnerDOB.js screen.
export default function SecondOwnerBirthday({ value, onChange } = {}) {
  const isControlled = value !== undefined;
  const { state, dispatch } = useContext(GlobalContext);
  // No default date — starts genuinely empty until actually picked, same
  // as the primary applicant's Birthday.js.
  const [uncontrolledDob, setUncontrolledDob] = useState(
    state?.questions?.business?.secondOwnerDob
      ? dayjs(reformatDate(state?.questions?.business?.secondOwnerDob))
      : null
  );
  const dob = isControlled ? value : uncontrolledDob;
  const setDob = isControlled ? onChange : setUncontrolledDob;
  function extractDateFromDateObject(dateObject) {
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  function reformatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");
    const year = dateObject.getFullYear();

    const formattedDate = `${month}-${day}-${year}`;

    return formattedDate;
  }
  useLayoutEffect(() => {
    if (isControlled || !dob) return;
    const dateObject = new Date(dob);
    let obj = { ...state.questions?.business };
    obj.secondOwnerDob = extractDateFromDateObject(dateObject);
    dispatch({
      type: "QUESTION_BUSINESS",
      payload: obj,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dob]);
  return (
    <div className="pd6-dob-field">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={null}
          value={dob}
          onChange={(newValue) => setDob(newValue)}
          maxDate={dayjs()}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: "outlined",
              placeholder: "MM/DD/YYYY",
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
}
